<template>
  <aside
    :class="{
      'left-sidebar': true,
      'sidebar-active': showContextMenu,
      'is-showing-qr-code-panel': isShowingQRCodePanel
    }"
    data-sidebarbg="skin5"
    id="left-sidebar"
  >
    <!-- Sidebar navigation-->
    <div
      class="exit-presenting-mode-overlay"
      id="context-exit-overlay"
      :class="{'overlay-presenting': $store.getters.isPresenting}"
    />
    <nav
      class="sidebar-nav vertical layout end-justified"
      style="height: 100%; z-index: 999; background: '#2f323e'; transform: translate(0);"
    >
      <ul id="sidebarnav" class="in">
        <li
          class="sidebar-item pointer"
          v-if="isEnableAddinPowerpoint"
          @click="reloadPPT()"
        >
          <a class="sidebar-link-custom sidebar-link waves-effect waves-dark">
            <i class="fas fa-sync fa-fw sidebar-link-icon"></i>
            <span class="hide-menu nav-left-text">{{ $t('Reload') }}</span>
          </a>
        </li>
        <!-- Stop presenting -->
        <li
          class="sidebar-item pointer"
          @click.stop="stopPresenting"
          v-if="!$store.state.isPlayDemoMode && !isMSTeamsApp && !isEnableAddinPowerpoint &&
            !hideStopPresenting"
        >
          <a class="sidebar-link-custom sidebar-link waves-effect waves-dark">
            <i class="fas fa-times-circle fa-fw sidebar-link-icon" />
            <span class="hide-menu nav-left-text pt-0.5">{{ $t('Stop presenting') }}</span>
          </a>
        </li>

        <!-- Devider -->
        <div class="devider" />

        <BackstageSetting v-if="!isNewPresentation && !isMSTeamsApp && !isEnableAddinPowerpoint" />

        <!-- Switch to windowed view -->
        <li
          class="sidebar-item pointer"
          @click.stop="toggleWindowedMode"
          v-if="_checkShowSwitchScreen() && !isEnableAddinPowerpoint"
        >
          <a class="sidebar-link-custom sidebar-link waves-effect waves-dark">
            <span v-if="screenState == 1" class="horizontal layout start">
              <i class="far fa-window-maximize fa-fw sidebar-link-icon" />
              <span class="hide-menu nav-left-text pt-3px">
                {{ $t('Switch to windowed view') }}
              </span>
            </span>
            <span v-if="screenState == 2" class="horizontal layout start">
              <i class="fas fa-expand-alt fa-fw sidebar-link-icon" />
              <span class="hide-menu nav-left-text pt-3px">
                {{ $t('Switch to full screen') }}
              </span>
            </span>
          </a>
        </li>

        <!-- Profanity filter -->
        <li
          class="sidebar-item pointer"
          @click.stop="toggleProfanityFilter()"
          v-if="profanityFilterVisible"
        >
          <a class="sidebar-link-custom sidebar-link waves-effect waves-dark">
            <span class="horizontal layout center">
              <i class="fas fa-asterisk fa-fw sidebar-link-icon" />
              <span
                class="hide-menu nav-left-text"
                v-if="!presentation.filteringProfanity"
              >{{ $t('Filter profanity') }}
              </span>
              <span
                class="hide-menu nav-left-text"
                v-else
              >{{ $t('Allow profanity') }}
              </span>
            </span>
          </a>
        </li>

        <!-- Show percentage -->
        <li
          class="sidebar-item pointer"
          @click.stop="editSettings(3)"
          v-if="$store.state.slideActive.type == 'multipleChoice' ||
            $store.state.slideActive.type == 'imageChoice'"
        >
          <a
            class="sidebar-link waves-effect waves-dark sidebar-link-custom"
            v-if="$store.state.slideActive.showPercentage"
          >
            <span class="percentage-number-icon sidebar-link-icon">123</span>
            <span
              class="hide-menu nav-left-text percentage-number-text pt-0.5"
            >{{ $t('Show results in absolute numbers') }}</span>
          </a>
          <a
            class="sidebar-link waves-effect waves-dark sidebar-link-custom"
            v-if="!$store.state.slideActive.showPercentage"
          >
            <i class="fas fa-percent fa-fw sidebar-link-icon" />
            <span
              class="hide-menu nav-left-text percentage-number-text pt-0.5"
            >{{ $t('Show results in percentage') }}</span>
          </a>
        </li>

        <!-- Show scale average line -->
        <li
          class="sidebar-item pointer item-hover"
          @click.stop="toggleShowAverageLine"
          v-if="$store.state.slideActive.type == 'scale' && $store.state.slideActive.scale"
        >
          <a
            class="sidebar-link waves-effect waves-dark sidebar-link-custom"
            v-if="$store.state.slideActive.scale.showAverage"
          >
            <i class="fas fa-sliders-h sidebar-link-icon" />
            <span class="hide-menu nav-left-text">{{ $t('Hide average line') }}</span>
          </a>
          <a
            class="sidebar-link waves-effect waves-dark sidebar-link-custom"
            v-else
          >
            <i class="fas fa-sliders-h sidebar-link-icon" />
            <span class="hide-menu nav-left-text">{{ $t('Show average line') }}</span>
          </a>
        </li>

        <!-- Change layout live -->
        <li
          class="sidebar-item pointer change-layout-live"
          @mouseenter="_openSecondLevelMenu"
          @mouseleave="_closeSecondLevelMenu"
        >
          <a
            v-if="isSettingChangeLayoutVisible"
            class="sidebar-link waves-effect waves-dark sidebar-link-custom"
            :class="{'disabled': isOpenEndedGroupingLayout}"
          >
            <i class="fas fa-comments sidebar-link-icon" />
            <span class="hide-menu nav-left-text pt-3px">{{ $t('Change layout') }}</span>
            <i class="fas fa-chevron-right context-menu-arrow-right pt-0.5" />
          </a>
          <ul
            class="context-menu-second-level"
            ref="second-level-menu"
            :class="{'d-block': openSecondLevelMenu}"
            v-if="isMultipleOrImageChoice"
          >
            <li
              class="sidebar-item pointer"
              :class="{'active': item.type == slideActive.typeChart}"
              v-for="item in chartTypes"
              :key="item.type"
              @click.stop="changeType(item, slideActive.type)"
            >
              <a class="pl-2 sidebar-link waves-effect waves-dark sidebar-link-custom">
                <i :class="item.icon" v-if="item.type != 'donutChart'" />
                <img
                  src="../../assets/images/icon/donutcharticon.png"
                  class="donut-chart-icon"
                  v-show="item.type == 'donutChart'"
                >
                <img
                  src="../../assets/images/icon/donutcharticon-active.png"
                  class="donut-chart-icon--active"
                  v-show="item.type == 'donutChart'"
                >
                <span class="hide-menu nav-left-text">{{ item.name === 'Bars' ? $t('Bars') :
                  (item.name === 'Donut' ? $t('Donut') : $t('Pie')) }}</span>
              </a>
            </li>
          </ul>
          <ul
            class="context-menu-second-level"
            :class="{'d-block': openSecondLevelMenu}"
            v-if="slideActive.type == 'openEnded'"
          >
            <li
              class="sidebar-item pointer"
              :class="{'active': item.type == slideActive.layout}"
              v-for="item in layouts"
              :key="item.type"
              @click.stop="changeType(item, slideActive.type)"
            >
              <a class="sidebar-link waves-effect waves-dark sidebar-link-custom">
                <i :class="item.icon" />
                <span class="hide-menu nav-left-text">{{ item.name === 'Grid' ?
                  $i18nPresenter.t('Grid') : $i18nPresenter.t('One by one') }}</span>
              </a>
            </li>
          </ul>
        </li>
        <!-- Show QR code   -->
        <li class="sidebar-item pointer" @click.stop="showQrcode()">
          <a class="sidebar-link waves-effect waves-dark sidebar-link-custom">
            <i class="fas fa-qrcode fa-fw sidebar-link-icon" />
            <span
              class="hide-menu nav-left-text pt-0.5"
              v-if="!isQRCodeVisible"
            >{{ $t('Show QR code') }}</span>
            <span
              class="hide-menu nav-left-text pt-0.5"
              v-if="isQRCodeVisible"
            >
              {{ $t('Hide QR code') }}
            </span>
          </a>
        </li>
        <!-- Hide instruction bar -->
        <li class="sidebar-item pointer" @click.stop="toggleHideInstructionBar()">
          <a
            class="sidebar-link waves-effect waves-dark sidebar-link-custom"
            v-if="$store.state.slideActive.type != 'document' &&
              $store.state.slideActive.type != 'googleSlides'"
          >
            <i class="fas fa-info-circle fa-fw sidebar-link-icon" />
            <span
              class="hide-menu nav-left-text pt-0.5"
              v-if="$store.state.presentation.hideInstructionBar"
            >{{ $t('Show instruction bar') }}</span>
            <span
              class="hide-menu nav-left-text pt-0.5"
              v-if="!$store.state.presentation.hideInstructionBar"
            >{{ $t('Hide instruction bar') }}</span>
          </a>
          <a
            class="sidebar-link waves-effect waves-dark sidebar-link-custom"
            v-if="$store.state.slideActive.type == 'document' ||
              $store.state.slideActive.type == 'googleSlides'"
          >
            <i class="fas fa-info-circle fa-fw sidebar-link-icon" />
            <span
              class="hide-menu nav-left-text"
              v-if="$store.state.presentation.hideIntroBarDocument"
            >{{ $t('Show instruction bar') }}</span>
            <span
              class="hide-menu nav-left-text"
              v-if="!$store.state.presentation.hideIntroBarDocument"
            >{{ $t('Hide instruction bar') }}</span>
          </a>
        </li>

        <!-- Private Mode  -->
        <PrivateModeSetting />
        <ResetSlideResultsSetting v-if="resetSlideResultsSettingVisible" />
      </ul>
    </nav>
    <!-- End Sidebar navigation -->
  </aside>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import screenfull from 'screenfull'
import * as Sentry from '@sentry/vue'
import {
  SET_CURRENT_SLIDE_MODE,
  FULL_SCREEN_MODE,
  WINDOWED_MODE,
  EDIT_MODE,
} from '@/vuex/types'
import Config from '@/config'
import Util from '@/util'
import Socket from '@/socket'
import Constant from '@/constant'
import { INPUT_METHODS } from '@/constant/inputMethods.constants'
import EventBus from '@/eventBus'
import eventCategories from '@/constant/eventCategories'
import SlideApi from '@/api/slide'

import BackstageSetting from '@/components-v2/presentation-editor/context-menu/BackstageSetting.vue'
import PrivateModeSetting from '@/components-v2/presentation-editor/context-menu/PrivateModeSetting.vue'
import ResetSlideResultsSetting from '@/components-v2/presentation-editor/context-menu/ResetSlideResultsSetting.vue'

const tracker = Util.gaTrackEventFactory({
  eventCategory: Config.US_PRESENTING_MODE,
  eventLabel: Config.LABEL_USER_INTERACTION,
}).bind(Util)

export default {
  components: {
    BackstageSetting,
    PrivateModeSetting,
    ResetSlideResultsSetting,
  },
  props: ['showContextMenu', 'isShowingQRCodePanel'],
  data() {
    return {
      chartTypes: [],
      layouts: [],
      isMSTeamsApp: !!Util.getParamValue('ms-teams', window.location.href),
      openSecondLevelMenu: false,
      openSecondLevelMenuTimeLimit: false,
      screenState: '',
      timeLimitOptions: [
        { number: 45, label: 'seconds', seconds: 45 },
        { number: 90, label: 'seconds', seconds: 90 },
        { number: 3, label: 'minutes', seconds: 180 },
        { number: 5, label: 'minutes', seconds: 300 },
        { number: 10, label: 'minutes', seconds: 600 },
        { number: 15, label: 'minutes', seconds: 900 },
        { number: 20, label: 'minutes', seconds: 1200 },
      ],
      hideStopPresenting: false,
    }
  },
  computed: {
    ...mapGetters('zoomApp', ['isZoomReady']),
    ...mapGetters('presentationHotKeyModule', ['hotKeyTrackingData']),
    ...mapState({
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slideActive,
      isNewPresentation: (state) => state.isNewPresentation,
      currentUser: (state) => state.currentUser,
      isQRCodeVisible: (state) => state.isQRCodeVisible,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
      isOpenEndedGroupingLayout: (state) => state.slideActive.isOpenEndedGroupingLayout,
      integrationPlatform: (state) => state.integrationPlatform,
    }),
    hasTimeLimitOption() {
      return this.$store.state.slideActive.type === 'imageChoice' ||
       this.$store.state.slideActive.type === 'multipleChoice' ||
       this.$store.state.slideActive.type === 'openEnded' ||
       this.$store.state.slideActive.type === 'scale' ||
       this.$store.state.slideActive.type === 'wordCloud'
    },
    hasTimeLimit() {
      return !!this.$store.state.slideActive.hasTimeLimit
       && !JSON.parse(this.$store.state.presentation.audiencePacing)
    },
    profanityFilterVisible() {
      const slideTypes = ['openEnded', 'wordCloud', 'question', 'pickAnswer', 'leaderboard', 'spinnerWheel', 'ideas']
      return slideTypes.includes(this.slideActive.type)
    },
    backgroundMusicToggleVisible() {
      const slideTypes = ['pickAnswer', 'leaderboard']
      return slideTypes.includes(this.slideActive.type)
    },
    isSettingChangeLayoutVisible() {
      const slideTypes = ['multipleChoice', 'openEnded', 'imageChoice']
      return slideTypes.includes(this.slideActive.type)
    },
    isMultipleOrImageChoice() {
      const slideTypes = ['multipleChoice', 'imageChoice']
      return slideTypes.includes(this.slideActive.type)
    },
    resetSlideResultsSettingVisible() {
      const slideTypes = ['leaderboard', 'freestyle', 'bulletPoints', 'youtube', 'qrcode', 'googleSlides', 'document', 'miro']
      return !slideTypes.includes(this.slideActive.type)
    },
  },
  created() {
    Object.keys(Constant.chartTypes).forEach((item) => {
      this.chartTypes.push(Constant.chartTypes[item])
    })
    Object.keys(Constant.openEndedLayout).forEach((item) => {
      this.layouts.push(Constant.openEndedLayout[item])
    })
  },
  mounted() {
    if (Util.getParamValue('presentFrom')) {
      this.hideStopPresenting = true
    }
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncLoadingAction', 'toggleQRCodePanelAction']),
    ...mapActions('zoomApp', [
      'detachPresentationToZoomMeetingAction',
    ]),
    _checkShowSwitchScreen() {
      if (!screenfull || this.$store.state.isPlayDemoMode) {
        return false
      }

      if (this.$store.state.currentSlideMode === 'fullScreenMode') {
        this.screenState = 1
        return true
      }

      if (this.$store.state.currentSlideMode === 'windowedMode') {
        this.screenState = 2
        return true
      }

      return false
    },
    showQrcode() {
      this.toggleQRCodePanelAction(!this.isQRCodeVisible)
      this.$emit('hideMenu')
      this.trackToggleQRCode()
    },
    trackToggleQRCode() {
      // Need to reconfirm with Chloe to see if we need to track context menu event
      const eventName = 'Show/Hide QR code'
      const {
        eventCategory,
        presentationId,
        userId,
      } = this.hotKeyTrackingData
      const eventLabel = this.isQRCodeVisible ? 'Hide' : 'Show'
      Util.mixpanelTracking(eventCategory, eventName, eventLabel, null, {
        presentationId,
        userId,
        method: INPUT_METHODS.MOUSE,
      })
    },
    toggleShowAverageLine() {
      this.editSettings(14)
    },
    showEditMode() {
      tracker({ eventAction: 'Presenter switch to edit mode using context menu' })
      this.$store.dispatch(SET_CURRENT_SLIDE_MODE, EDIT_MODE)
      this.$emit('hideFullScreen')
    },
    async stopPresenting() {
      Util.setCurrentWindowMode()
      this.toggleQRCodePanelAction(false)
      if (this.isZoomReady) {
        this.detachPresentationToZoomMeetingAction()
        this.$router.push({
          name: 'ZoomPresentationList',
        })
        return
      }
      this.$router.replace({
        name: 'PresentationDetail',
        params: { id: this.$store.state.presentation.id },
      })
      EventBus.$emit('close-backstage-window')
      this.$emit('hideFullScreen')

      // TODO:
      // - Create "start" "stop" presentation API and move the scope below to server side
      // - There is duplicated code in Middle.vue (stopPresenting), move it to server side too.
      if (this.$store.state.slideActive.type == 'pickAnswer') {
        if (!this.$store.state.isAdmin) {
          try {
            await SlideApi.updateSlideById(this.slideActive.id, {
              quizStatus: Constant.QuizStatuses.LOBBY_SCREEN,
              socketId: Socket.getSocketId(),
              accessCode: this.$store.state.presentation.uniqueAccessCode,
              activeSlide: this.$store.state.slideActive.id,
              presentationId: this.$store.state.presentation.id,
              presenting: false,
            })
            this.$store.dispatch('setSyncPresentation', 3)
          } catch (error) {
            Sentry.captureException(error)
            return
          }
        }
      }

      if (
        this.$store.state.presentation.id &&
        !this.$store.state.isAdmin &&
        !this.$store.state.sharePresentation
      ) {
        const idLastSlide = Util.getLastSlide(
          this.$store.state.presentation.slides,
        )
        const payload = {
          presenting: false,
          socketId: Socket.getSocketId(),
          activeSlidePreseting: this.$store.state.slideActive.id,
          activeSlideAccessCode: this.$store.state.presentation.uniqueAccessCode,
        }
        if (
          idLastSlide &&
          idLastSlide != this.$store.state.presentation.lastSlide
        ) {
          payload.lastSlide = idLastSlide
          this.$store.state.presentation.lastSlide = idLastSlide
        }
        this.$http
          .put(
            Config.api.updatePresentation + this.$store.state.presentation.id,
            payload,
          )
          .then(() => {
            return true
          })
          .catch((err) => {
            Sentry.captureException(err)
          })
      }
      // END OF TODO

      Util.mixpanelTracking(
        'Presentation',
        'Stop presenting',
        'Presenter stop presenting',
      )
    },
    async toggleWindowedMode() {
      try {
        if (this.$store.getters.isFullScreenMode) {
          screenfull.exit()
          this.$store.dispatch(SET_CURRENT_SLIDE_MODE, WINDOWED_MODE)

          // AHA-890 Remember fullscreen setting
          const payload = {
            fullscreen: false,
          }
          const result = await this.$http
            .put(Config.api.updateUserSettings, payload)
          this.$store.state.currentUser.rememberSettings
            = result.body.rememberSettings

          Util.mixpanelTracking('Presentation', 'Switch screen mode', 'Presenter switch to windowed mode')
          return
        }

        if (this.$store.getters.isWindowedMode) {
          screenfull.request()

          this.$store.dispatch(SET_CURRENT_SLIDE_MODE, FULL_SCREEN_MODE)

          // AHA-890 Remember fullscreen setting
          const payload = {
            fullscreen: true,
          }
          const result = await this.$http
            .put(Config.api.updateUserSettings, payload)
          this.$store.state.currentUser.rememberSettings
            = result.body.rememberSettings

          Util.mixpanelTracking('Presentation', 'Switch screen mode', 'Presenter switch to full screen mode')
        }
      } catch (error) {
        Sentry.captureException(error)
      }
    },
    hideContextMenu() {
      this.$emit('hideFullScreen')
    },
    editSettings(type) {
      this.$emit('hideFullScreen')
      const params = {
        accessCode: this.$store.state.presentation.uniqueAccessCode,
        socketId: Socket.getSocketId(),
      }
      if (type === 1) {
        params.hideResult = !this.$store.state.slideActive.hideResult
        this.updateSlideActiveAction({
          hideResult: params.hideResult,
        })
      } else if (type === 3) {
        params.showPercentage = !this.$store.state.slideActive.showPercentage
        this.updateSlideActiveAction({
          showPercentage: params.showPercentage,
        })
      } else if (type === 14) {
        params.scale = {
          ...this.$store.state.slideActive.scale,
          showAverage: !this.$store.state.slideActive.scale.showAverage,
        }
        this.updateSlideActiveAction({
          scale: params.scale,
        })
      }
      this.$store.dispatch('setSyncPresentation', 1)
      params.presenting = this.$store.getters.isPresenting
      this.$http
        .put(Config.api.updateSlide + this.$store.state.slideActive.id, params)
        .then(
          () => {
            if (type === 1) {
              Util.mixpanelTracking(
                'Slide',
                'Edit setting',
                'Presenter edit setting hide result',
                this.$store.state.slideActive.hideResult,
              )
            } else if (type === 3) {
              Util.mixpanelTracking(
                'Slide',
                'Edit setting',
                'Presenter edit setting show percentage chart',
              )
            } else if (type === 14) {
              const action = this.$store.state.slideActive.scale.showAverage ? 'Show' : 'Hide'
              Util.mixpanelTracking(
                'Presentation > Context Menu > Show Average Line',
                `${action} Average Line`,
                'Presenter show/hide Average Line',
              )
            }
            this.$store.dispatch('setSyncPresentation', 2)
          },
          () => {
            this.$store.dispatch('setSyncPresentation', 3)
          },
        )
    },

    async changeType(item, type) {
      const payload = {}
      if (type === 'multipleChoice' || type === 'imageChoice') {
        payload.typeChart = item.type
        this.updateSlideActiveAction({
          typeChart: item.type,
        })
      } else {
        if (this.isOpenEndedGroupingLayout) return
        payload.layout = item.type
        this.updateSlideActiveAction({
          layout: item.type,
        })
      }
      payload.presentationId = this.$store.state.presentation.id
      payload.accessCode = this.$store.state.presentation.uniqueAccessCode
      payload.socketId = Socket.getSocketId()
      this.setSyncLoadingAction(1)
      Util.uploadSlide(
        this.$store.state.slideActive,
        this.$store.state.presentation,
      )
      payload.presenting = this.$store.getters.isPresenting || this.$store.getters.isBackstage
      try {
        await SlideApi.updateSlideById(this.slideActive.id, payload)
        this.setSyncLoadingAction(2)
        Util.mixpanelTracking(
          eventCategories.PRESENTING_MODE,
          'Context menu > Change layout',
          `Slide type: ${type} - Layout: ${item.type}`,
        )
      } catch (error) {
        Sentry.captureException(error)
        this.setSyncLoadingAction(3)
      }
    },

    toggleProfanityFilter() {
      this.presentation.filteringProfanity = !this.presentation.filteringProfanity
      const payload = {
        filteringProfanity: this.presentation.filteringProfanity,
      }
      Util.mixpanelTracking(
        eventCategories.PRESENTING_MODE,
        `Menu > Profanity Filter > ${this.presentation.filteringProfanity ? 'Filter on' : 'Filter off'}`,
      )
      this._updatePresentation(payload)
    },

    toggleHideInstructionBar() {
      const slideTypes = ['document', 'googleSlides', 'freestyle']
      let payload = {}
      if (slideTypes.includes(this.slideActive.type)) {
        this.presentation.hideIntroBarDocument = !this.presentation.hideIntroBarDocument
        payload = {
          hideIntroBarDocument: this.presentation.hideIntroBarDocument,
        }
      } else {
        this.presentation.hideInstructionBar = !this.presentation.hideInstructionBar
        payload = {
          hideInstructionBar: this.presentation.hideInstructionBar,
        }
      }
      Util.mixpanelTracking(
        eventCategories.PRESENTING_MODE,
        'Menu > Show/ Hide instruction bar',
      )
      this._updatePresentation(payload)
    },

    _updatePresentation(payload) {
      this.$http.put(
        Config.api.updatePresentation + this.presentation.id,
        payload,
      ).then(() => {
        return true
      }).catch(() => {
        return false
      })
    },

    changeTimeToAnswer(value) {
      this.updateSlideActiveAction({
        timeToAnswer: value,
      })
      EventBus.$emit('resetTimeToAnswer')
      Util.mixpanelTracking('Slide update', 'Update time limit from Menu', value)
    },

    _openSecondLevelMenu() {
      if (this.isSettingChangeLayoutVisible && this.isOpenEndedGroupingLayout) return
      this.openSecondLevelMenu = true
      this._setBackdropZ('99')
    },

    _closeSecondLevelMenu() {
      this.openSecondLevelMenu = false
      this._setBackdropZ('999')
    },

    _openSecondLevelMenuTimeLimit() {
      this.openSecondLevelMenuTimeLimit = true
      this._setBackdropZ('99')
    },

    _closeSecondLevelMenuTimeLimit() {
      this.openSecondLevelMenuTimeLimit = false
      this._setBackdropZ('999')
    },

    _setBackdropZ(z) {
      const backdrop = document.getElementsByClassName('backdrop')[0]
      if (backdrop) {
        backdrop.style.zIndex = z
      }
    },
    reloadPPT() {
      window.location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.left-sidebar {
  font-family:Nunito;
  padding-top: 0;
  transition: transform 0.3s ease;
  transform: translate(-250px);
  background: #2f323e;
  left: -250px;
  position: fixed;
  z-index: 900;
  width: 250px;
  .sidebar-nav ul {
    padding-bottom: 50px;
    @media (max-width: 812px) and (orientation: landscape) {
      padding-bottom: 90px;
    }
  }
  .sidebar-item {
    width: unset;
    .sidebar-link {
      &.sidebar-link-custom {
        white-space: normal;
        line-height: 23px;
      }
      &.disabled, &.disabled:hover {
        color: #707070 !important;
        cursor: not-allowed;
        .sidebar-link-icon, .fas, .far {
          color: #707070 !important;
          cursor: not-allowed;
        }
      }
      .donut-chart-icon--active {
        display: none;
      }
      &:hover {
        .fas, .far {
          color: $primary-color;
        }
        .donut-chart-icon--active {
          display: block;
        }
        .donut-chart-icon {
          display: none;
        }
      }
      .sidebar-link-icon {
        font-size: 20px;
        margin-right:12px;
      }
      .percentage-number-icon {
        font-size: 80%;
        width: 29.65px;
        margin-right: 17px;
      }
      .percentage-number-text {
        white-space: pre-line;
      }
    }
    .active {
      background-color: rgba(0, 0, 0, 0.07);
    }
    .nav-left-text {
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      -ms-flex: 1;
      flex: 1;
      font-size: 16px;
    }
  }
  ::v-deep {
    .sidebar-item {
      .sidebar-link {
        &:hover {
          svg {
            color: $primary-color;
          }
        }
      }
    }
  }

  &.sidebar-active {
    transform: translate(0);
    overflow: visible;
    left: 0;
    .sidebar-nav::after {
      width: 400vw;
      height: 100%;
      opacity: 1;
      overflow-x: hidden;
    }
  }
  &.is-showing-qr-code-panel {
    transform: translate(0) scale(0.8);
    &.sidebar-active {
      transform: translate(92%) scale(0.8);
    }
  }
}
.sidebar-nav {
  position: relative;
  .devider {
    margin: 0;
  }
}

.sidebar-nav::after {
  position: absolute;
  content: "";
  display: block;
  background-color: rgba(0, 0, 0, 0.7);
  opacity: 0;
  width: 0;
  height: 0;
  left: 100%;
  top: 0;
  z-index: 1000;
  -webkit-transition: opacity 0.2s ease-in-out;
  transition: opacity 0.2s ease-in-out;
}

.sidebar-nav ul .sidebar-item .sidebar-link {
  padding: 9px 15px 9px 12px;
  .context-menu-arrow-right {
    text-align: right;
    width: 15px;
    font-size: 15px;
  }
}

.change-layout-live {
  position: relative;
}

.context-menu-second-level {
  display: none;
  position: absolute;
  overflow: hidden;
  top: 0;
  z-index: 1001;
  height: fit-content;
  left: 100%;
  background: #2f323e;
  font-size: 15px;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  width: 249px;
  .donut-chart-icon, .donut-chart-icon--active {
    width: 27px;
    height: 27px;
    margin: 0 4px;
  }
}

.time-limit-options {
  top: -90px;
}
</style>
